// Each Rollbar Error will have a fingerprint added to it now.
// We want to place those fingerprints here in this array if we want to have Rollbar ignore them.
// We should add a comment after pointing to the original rollbar for easy reference.
// 'b2162c81c9e750410aff9203d2ddcf924039225bd2a050dc9db9aa63d570396f', // https://rollbar.com/uniteus/app-client/items/450/

const BLACKLISTED_HASHES = [];

export default BLACKLISTED_HASHES;
